import moment from 'moment'
import { has } from 'lodash'

// data types
export const CURRENCY = 'currency'
export const STRING = 'string'
export const DATE = 'date'
export const NUMBER = 'number'
export const OBJECT = 'object'
export const BOOLEAN = 'boolean'

// ordering
export const ASC = 'asc'
export const DES = 'des'

export function actionType(path, type) {
  return `${path}.${type}`
}

export function statePath(state, path) {
  return path.split('.').reduce((prev, p) => {
    return prev[p]
  }, state)
}

export function objectPath(state, path) {
  return path.split('.').reduce((prev, p) => {
    return prev[p]
  }, state)
}

function date(d) {
  return moment(d).format('X')
}

function toUpperCase(str) {
  const s = str ? String(str) : ''
  return s.toUpperCase()
}

export function prefixAction(prefix, type) {
  return `${prefix}.${type}`
}

export function sortByFunc(sortByKey, order, schema) {
  return (aObj, bObj) => {
    const a = aObj[sortByKey]
    const b = bObj[sortByKey]

    // defaults to string
    if (!has(schema[sortByKey], 'sortType')) {
      const nameA = toUpperCase(a)
      const nameB = toUpperCase(b)

      if (nameA < nameB) {
        return order === ASC ? -1 : 1
      }
      if (nameA > nameB) {
        return order === ASC ? 1 : -1
      }
      return 0
    } else if (schema[sortByKey].sortType === NUMBER) {
      // number
      return order === ASC ? a - b : b - a
    } else if (schema[sortByKey].sortType === DATE) {
      // date
      return order === ASC ? date(a) - date(b) : date(b) - date(a)
    } else if (schema[sortByKey].sortType === BOOLEAN) {
      // date
      return order === ASC ? a.selected - b.selected : b.selected - a.selected
    }
  }
}
